import { Category, SubCategory } from "lib/api";
import { ApiArrayResponse } from "lib/api/axiosConfig";
import { CategoryFormData, CategoryFormType } from "../AddEditCategoryDialog";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export declare type MutatorCallback<Data = any> = (
  currentValue: undefined | Data
) => Promise<undefined | Data> | undefined | Data;

export declare type SwrCatMutate = (
  data?:
    | ApiArrayResponse<Category>
    | Promise<ApiArrayResponse<Category>>
    | MutatorCallback<ApiArrayResponse<Category>>
    | undefined,
  shouldRevalidate?: boolean | undefined
) => Promise<ApiArrayResponse<Category> | undefined>;

export declare type SwrSubCatMutate = (
  data?:
    | ApiArrayResponse<SubCategory>
    | Promise<ApiArrayResponse<SubCategory>>
    | MutatorCallback<ApiArrayResponse<SubCategory>>
    | undefined,
  shouldRevalidate?: boolean | undefined
) => Promise<ApiArrayResponse<SubCategory> | undefined>;

const sortCat = (a: Category, b: Category) => {
  const nameA = a.cat_name.toUpperCase();
  const nameB = b.cat_name.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

const sortSubCat = (a: SubCategory, b: SubCategory) => {
  const nameA = a.sub_cat_name.toUpperCase();
  const nameB = b.sub_cat_name.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

export const mutateData = (
  data: CategoryFormData,
  type: CategoryFormType,
  mutateCat: SwrCatMutate,
  mutateSubcat: SwrSubCatMutate,
  addCategory: (data: Partial<Category>) => Promise<Category>,
  addSubCategory: (data: Partial<SubCategory>) => Promise<SubCategory>
): Promise<ApiArrayResponse<Category | SubCategory> | undefined> => {
  if (type === "category") {
    return mutateCat(async (categories) => {
      const newCategory = await addCategory({
        cat_name: data.name,
        cat_desc: data.description,
      });
      const newCategories = {
        data: categories ? [...categories.data, newCategory] : [newCategory],
        totalCount: categories ? categories.totalCount + 1 : 1,
      };
      newCategories.data.sort(sortCat);
      return newCategories;
    }, false);
  }
  return mutateSubcat(async (subcategories) => {
    const newSubcategory = await addSubCategory({
      sub_cat_name: data.name,
      sub_cat_desc: data.description,
    });
    const newSubcategories = {
      data: subcategories
        ? [...subcategories.data, newSubcategory]
        : [newSubcategory],
      totalCount: subcategories ? subcategories.totalCount + 1 : 1,
    };
    newSubcategories.data.sort(sortSubCat);
    return newSubcategories;
  }, false);
};
